import { useLocation } from 'react-router-dom'
import { Seo } from '../Seo'
import { getSeoForPath } from '../../seo/config'

export function PageSeoManager() {
  const { pathname } = useLocation()
  const seoConfig = getSeoForPath(pathname)

  if (!seoConfig) return null

  return <Seo {...seoConfig} />
}
